import qs from 'qs'
import Vue from 'vue'
import AES from '@/utils/aes'

var token = {
  savetoken: function (token) {
    // console.log(token)
    // session中存储
    sessionStorage.setItem('access_token', token.access_token)
    sessionStorage.setItem('enabled', token.enabled)
    sessionStorage.setItem('expires_in', token.expires_in)
    sessionStorage.setItem('refresh_token', token.refresh_token)
    sessionStorage.setItem('token_type', token.token_type)
    sessionStorage.setItem('scope', token.token_type)
    // 在cookie中也保存一份
    // console.log('cookie中存储token')
    Vue.prototype.$cookies.set('access_token', AES.Encrypt(token.access_token))
    // console.log(Vue.prototype.$cookies.get('access_token'))
  },
  deleteToken: function () {
    sessionStorage.setItem('access_token', null)
    sessionStorage.setItem('enabled', null)
    sessionStorage.setItem('expires_in', null)
    sessionStorage.setItem('refresh_token', null)
    sessionStorage.setItem('token_type', null)
    // 清除cookie中的token
    Vue.prototype.$cookies.remove('access_token')
    localStorage.removeItem('noticeWithdraw')
  },
  loadToken: function () {
    const tokenInfo = {}
    tokenInfo.access_token = AES.Decrypt(Vue.prototype.$cookies.get('access_token'))
    tokenInfo.enabled = sessionStorage.getItem('enabled')
    tokenInfo.expires_in = sessionStorage.getItem('expires_in')
    tokenInfo.refresh_token = sessionStorage.getItem('refresh_token')
    tokenInfo.token_type = sessionStorage.getItem('token_type')
    return tokenInfo
  },
  getTokenFromService: function (vue, code, callback, error) {
    vue.$ajax.post(vue.$config.accessTokenUri, qs.stringify({
      client_id: vue.$config.clientId,
      client_secret: vue.$config.client_secret,
      code: code,
      redirect_uri: vue.$config.redirect_uri,
      grant_type: vue.$config.grant_type
    }),
    {
      // headers: { 'Accept': 'application/json' }
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }
    )
      .then(callback)
      .catch(error)
  }

}

export default token
